export default "__VITE_ASSET__BnOr_$dF__"